import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Himanshu Gohel </span>
            from <span className="purple"> Ahmedabad, Gujarat.</span>
            <br /> 
            <br />
            I am currently seeking job opportunities to contribute 
            my skills to a dynamic team and grow professionally. 
            <br />
            <br />
            I have completed (B.Sc. IT) Bachlor of Science in Information Technology 
            at K S School of Business Management, Ahmedabad.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
            <li className="about-activity">
              <ImPointRight /> Learn New Things
            </li>
            <li className="about-activity">
              <ImPointRight /> Watching Movie
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Set your goals high, and don't stop till you get there!"{" "}
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
